import { cva } from 'class-variance-authority';

export const toggleVariants = cva(
  'eye:inline-flex eye:cursor-pointer eye:items-center eye:justify-center eye:gap-2xs eye:rounded-md eye:px-2xs eye:outline-offset-3 eye:outline-black eye:transition-colors eye:focus-visible:outline-2 eye:focus-visible:outline-black eye:disabled:cursor-not-allowed eye:disabled:bg-grey-disabled eye:disabled:text-grey-disabled eye:aria-disabled:cursor-not-allowed eye:data-[disabled]:cursor-not-allowed eye:data-[state=on]:bg-black eye:data-[state=on]:text-white eye:[&_svg]:pointer-events-none eye:[&_svg]:size-[24px] eye:[&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'eye:bg-transparent eye:hover:bg-grey-20',
        outline:
          'eye:border-2 eye:border-black eye:hover:border-grey-120 eye:hover:text-grey-120 eye:focus-visible:border-grey-120 eye:focus-visible:text-grey-120 eye:disabled:bg-transparent',
      },
      size: {
        default: 'eye:h-[44px] eye:min-w-[44px]',
        sm: 'eye:h-[35px] eye:min-w-[35px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
